import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { DrawerComponent } from './drawer/drawer.component';
import { FooterComponent } from './footer/footer.component';
import { GivingSequenceComponent } from './giving-sequence/giving-sequence.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { PaymentViewComponent } from './payment-view/payment-view.component';
import { SeminavComponent } from './seminav/seminav.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
	declarations: [
		FooterComponent,
		NavbarComponent,
		SidebarComponent,
		LanguageSwitchComponent,
  		SeminavComponent,
		DrawerComponent,
		NavigationComponent,
		GivingSequenceComponent,
		PaymentViewComponent
	],
	imports: [
		CommonModule, 
		RouterModule, 
		FormsModule,
		ReactiveFormsModule,
		SharedModule, 
		TranslateModule
	],
	exports: [
		FooterComponent,
		NavbarComponent,
		SidebarComponent,
		LanguageSwitchComponent,
		SeminavComponent,
		DrawerComponent,
		NavigationComponent,
		GivingSequenceComponent,
		PaymentViewComponent
	],
})
export class ComponentsModule {}
